import { store, storeActions } from '~/utility/BinSentry-ui-utility';
import { html } from '~/lib/bn-lit-element';
import '../error-pages/page-not-found';

export const IndexMixin = (superClass) => class extends superClass {
  constructor() {
    super();
    this.indexReady = true;
  }

  static get properties() {
    return {
      path: { type: String },
      tail: { type: String },
      currentView: { type: String, attribute: false },
      indexReady: { type: Boolean, attribute: false },
    };
  }

  render() {
    this.__trace('IndexMixin::render', { currentView: this.currentView });
    const views = this.getViews() || [];
    if (views.length === 0 || !this.indexReady) {
      return html``;
    }
    let view;
    if (this.currentView) {
      view = views.find((v) => Array.isArray(v.name) ? v.name.includes(this.currentView) : v.name === this.currentView);
    } else {
      view = views.find((v) => v.default === true);
      const { path, queryV2 } = store.getState();
      if (view) {
        const pathText = path || '';
        this.currentView = view.name;
        store.dispatch(storeActions.replaceLocation(`${pathText}${pathText.endsWith('/') ? '' : '/'}${view.name}`, queryV2));
      }
    }
    if (!view) {
      // 404
      view = {
        render: () => html`<page-not-found></page-not-found>`,
      };
    }
    this.__trace({ view, currentView: this.currentView });
    return view.render();
  }

  update(changedProperties) {
    this.__trace('IndexMixin::update', { path: this.path });
    if (changedProperties.has('path')) {
      const parts = (this.path || '').toLowerCase().slice(1).split('/');
      this.tail = `/${parts.slice(1).join('/')}`;
      [this.currentView] = parts;
    }
    super.update(changedProperties);
  }

  getViews() {
    // array of views
    // this.views = [{ name: '', default: bool, render: () => html`` }, ...]
    return [];
  }
};
